var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('SoilNutrients',{attrs:{"results":_vm.results}}),_c('SoilCharacteristics',{attrs:{"results":_vm.results}}),_c('SoilTextureCharacteristics',{attrs:{"results":_vm.results}}),_c('LaboratoryGuidelines',{attrs:{"results":_vm.results}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }